import { DataService } from "../services/data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "../common/url";
@Injectable({
  providedIn: "root",
})
export class SpareInOutService extends DataService {
  constructor(http: HttpClient, private localHttp: HttpClient) {
    super("sparepartsinout", http);
  }

  url: string = Url.sparepartsinout;

  getAllResources(resource: any = {}, searchObject: any = {}) {
    let iId = resource.item ? `&filter[where][item]=${resource.item}` : "";
    let sFrom = resource.from ? `&filter[where][from]=${resource.from}` : "";
    let sTo = resource.to ? `&filter[where][to]=${resource.to}` : "";
    let engine = searchObject.engine
      ? `&filter[where][motorId]=${searchObject.engine}`
      : "";
    let powerCoach = searchObject.powerCoach
      ? `&filter[where][powerTrainId]=${searchObject.powerCoach}`
      : "";
    let fDate = searchObject.dateFrom
      ? `&filter[where][created][gt]=${searchObject.dateFrom}`
      : "";
    let tDate = searchObject.dateTo
      ? `&filter[where][created][lt]=${searchObject.dateTo}`
      : "";

    return this.localHttp.get(
      this.url +
        "?" +
        iId +
        fDate +
        tDate +
        sFrom +
        sTo +
        powerCoach +
        engine +
        "&filter[include]=stockfrom&filter[include]=stockto&filter[include]=spareparts&filter[include]=pt&filter[include]=moto&filter[order]=id DESC"
    );
  }

  delete(itemId: string) {
    return this.localHttp.delete(`${this.url}/${itemId}`);
  }
}
